// extracted by mini-css-extract-plugin
export default {"form":"CreateAPIKey_form__7vKNQ"};